import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import Divider from '@material-ui/core/Divider'
import { store } from '@redux/store'
import MaterialTable from 'material-table'
import { SaveAlt } from '@material-ui/icons'
import { Button, Grid } from '@material-ui/core'
import { PfSubPfSelect } from '@select'
import { addToast } from '../../utils/toast'
const initialState = {
    title: '',
    dialogOpen: false,
    pf_id: '',
    data: {},
    assignData: {},
    rankinputs: {},
    isTableLoading: false,
    openRoute: '',
    pageSize: 10
}

class EditGameRecommendDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'EditGameRecommendDialog')
        }
        this.state = initialState
    }

    state = {}

    columns = [
        {
            field: 'rankings',
            title: utils.t('rankings', 'GameRecommendDialog'),
            render: (rowData) => {
                return <div>{rowData.rankings}</div>
            },
        },
        {
            field: 'chineseName',
            title: utils.t('chineseName', 'GameRecommendDialog'),
            render: (rowData) => {
                return <div>{rowData.chineseName}</div>
            },
        },
        {
            field: 'englishName',
            title: utils.t('englishName', 'GameRecommendDialog'),
            render: (rowData) => {
                return <div>{rowData.englishName}</div>
            },
        },
        {
            field: 'action',
            title: utils.t('action', 'GameRecommendDialog'),
            render: (rowData) => {
                return (
                    <div>
                        <input
                            value={this.state.rankinputs[rowData.game_code] || ''}
                            onChange={(event) => {
                                const value = event.target.value.replace(/[^\d]/g, '')
                                if (String(value).charAt(0) === '0') return
                                this.setState(
                                    {
                                        rankinputs: {
                                            ...this.state.rankinputs,
                                            [rowData.game_code]: value,
                                        },
                                    }
                                )
                            }}
                            className={this.props.classes.sortInput}
                        />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                if (this.state.rankinputs[rowData.game_code]) {
                                    const newRank = Number(this.state.rankinputs[rowData.game_code])
                                    if (newRank === 0) return
                                    if (newRank > this.state.data.rank_info.length) {
                                        addToast(utils.t('sortQuantityOverload', 'GameRecommendDialog'), 'error')
                                        return
                                    }
                                    this.sortRank(rowData.game_code, newRank)
                                    this.setState({ rankinputs: {} })
                                }
                            }}
                            className={this.props.classes.sortButton}>
                            {this.t('confirm')}
                        </Button>
                    </div>
                )
            },
            cellStyle: {
                width: '195px',
            },
        },
    ]

    sortRank(gameCode, newRank) {
        const currentObject = this.state.data.rank_info.find((item) => item.game_code === gameCode)
        const cloneData = JSON.parse(JSON.stringify(this.state.data.rank_info))
        const currentRank = currentObject.rank
        if (currentObject) {
            if (currentRank === newRank || newRank === 0) return
            cloneData.forEach((item) => {
                const isCurrentGame_code = item.game_code === gameCode // 是否為要變更排名的 item
                if (isCurrentGame_code) {
                    item.rank = newRank
                    return
                }
                if (item.rank > currentRank && item.rank <= newRank) {
                    item.rank--
                }
                if (item.rank < currentRank && item.rank >= newRank) {
                    item.rank++
                }
            })

            cloneData.sort((a, b) => a.rank - b.rank)
            this.formatExportKey({ ...this.state.data, rank_info: cloneData })
            this.setState({ rankinputs: {}, data: { ...this.state.data, rank_info: cloneData } })
        }
    }

    setRankInfo(data) {
        this.setState({ data })
    }

    formatExportKey(data) {
        data.rank_info.forEach((item) => {
            const game = store.getState().dataService.gameList.find((gameListitem) => gameListitem.game_code === item.game_code)
            item.rankings = item.rank
            item.chineseName = game.name_chs
            item.englishName = game.name_enu
        })
        return data.rank_info
    }

    async queryAllGameData() {
        const APIPATH = this.state.openRoute === 'new-game-recommend-page' ? API.RECOMMENDATIONS_LATEST : API.RECOMMENDATIONS_TOP
        this.setTableLoading(true)
        utils.apiRequest(
            'get',
            APIPATH,
            {
                pf_id: this.state.pf_id,
            },
            (response) => {
                const { pf_id, ranks, updated_at } = response

                const data = {
                    pf_id: pf_id,
                    rank_info: ranks,
                    updated_at: updated_at,
                }

                data.rank_info = this.formatExportKey(data)
                this.setState({ data })
                this.setTableLoading(false)
            },
            (_err) => {
                this.initRankInfo()
            },
            true
        )
    }

    updateAllGameData() {
        const APIPATH = this.state.openRoute === 'new-game-recommend-page' ? API.RECOMMENDATIONS_LATEST : API.RECOMMENDATIONS_TOP
        this.setTableLoading(true)
        const { pf_id, rank_info: ranks } = this.state.data
        utils.apiRequest(
            'patch',
            APIPATH,
            { pf_id, ranks },
            (_data) => {
                this.confirm()
            },
            (_err) => {
                this.initRankInfo()
            },
            true
        )
    }

    reRankData() {
        this.setState({ assignData: JSON.parse(JSON.stringify(this.state.data)) })
        const APIPATH = this.state.openRoute === 'new-game-recommend-page' ? API.RECOMMENDATIONS_LATEST_REFRESH : API.RECOMMENDATIONS_TOP_REFRESH
        this.setTableLoading(true)
        utils.apiRequest(
            'patch',
            APIPATH,
            this.state.data,
            (_data) => {
                this.queryAllGameData()
            },
            (_err) => {
                this.initRankInfo()
            },
            true
        )
    }

    setTableLoading(isTableLoading) {
        this.setState({ isTableLoading })
    }

    OpenDialog(inputs) {
        const { pf_id, title, openRoute } = inputs
        this.setState({ dialogOpen: true, title, pf_id, openRoute }, async () => {
            await this.queryAllGameData()
            if (openRoute === 'popular-game-recommend-page') {
                this.allGamePfSubPfSelect.setState({
                    pfId: this.state.pf_id,
                })
            }
        })
    }

    closeDialog() {
        if (Object.keys(this.state.assignData).length > 0) {
            const APIPATH = this.state.openRoute === 'new-game-recommend-page' ? API.RECOMMENDATIONS_LATEST : API.RECOMMENDATIONS_TOP
            this.setTableLoading(true)
            const { pf_id, rank_info: ranks } = this.state.assignData
            utils.apiRequest(
                'patch',
                APIPATH,
                { pf_id, ranks },
                (_data) => {},
                (_err) => {
                    this.initRankInfo()
                },
                true
            )
        }
        this.setState(initialState)
    }

    confirm() {
        if (this.props.confirmCallback) {
            this.props.confirmCallback()
        }
        this.setState(initialState)
    }

    initRankInfo() {
        this.setState({
            data: {
                rank_info: [],
            },
        })
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    render() {
        return (
            <Dialog
                fullWidth
                maxWidth="md"
                open={this.state.dialogOpen}
                onClose={() => {
                    this.closeDialog()
                }}>
                <DialogTitle>{this.state.title}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        {this.state.openRoute === 'popular-game-recommend-page' && (
                            <Grid item className={this.props.classes.alignCenter}>
                                <PfSubPfSelect
                                    onRef={(ref) => (this.allGamePfSubPfSelect = ref)}
                                    options={{
                                        pfChangeCallback: () => {
                                            this.setState(
                                                {
                                                    pf_id: this.allGamePfSubPfSelect.state.pfId,
                                                },
                                                () => {
                                                    this.queryAllGameData()
                                                }
                                            )
                                        },
                                        hideAutocomplete: true,
                                        hideAllPlatform: true,
                                    }}
                                />
                            </Grid>
                        )}
                        <Grid item>
                            <Button
                                className={this.props.classes.refreshBtn}
                                variant="contained"
                                onClick={() => {
                                    this.reRankData()
                                }}
                                color="primary">
                                {utils.t('reRank', 'GameRecommendDialog')}
                            </Button>
                        </Grid>
                    </Grid>
                    <MaterialTable
                        isLoading={this.state.isTableLoading}
                        title={''}
                        components={{
                            Toolbar: () => {
                                return <></>
                            },
                        }}
                        icons={{ Export: SaveAlt }}
                        ownerName="EditGameRecommendDialog"
                        data={this.state.data.rank_info}
                        columns={this.columns}
                        options={{
                            exportButton: false,
                            export: false,
                            tableLayout: 'fixed',
                            pageSize: this.state.pageSize,
                            pageSizeOptions: [10, 30, 50, 100],
                            search: false,
                            sorting: false,
                        }}
                        onRef={(ref) => (this.table = ref)}
                        onChangeRowsPerPage={(pageSize) => {
                            this.setState({ pageSize })
                        }}
                    />
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.updateAllGameData()
                        }}
                        color="primary">
                        {this.t('confirm')}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.closeDialog()
                        }}
                        color="primary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        rerankBtn: {
            marginLeft: '10px',
        },
        sortInput: {
            width: '80px',
            height: '30px',
        },
        sortButton: {
            height: '30px',
            marginLeft: '15px',
            marginBottom: '5px',
        },
        refreshBtn: {
            marginTop: '19px',
            marginBottom: '10px',
        },
    }
}

EditGameRecommendDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
}

export default hoc(styles)(EditGameRecommendDialog)
